var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import AlertConstants from "./AlertConstants.js";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
const getDefaultState = () => {
  return {
    operationAlertResult: {
      status: AsyncRequestStatus.NotStarted,
      data: {
        experimentId: "",
        error: "",
        operationAlertDictionary: {}
      }
    },
    experimentJournalResult: {
      status: AsyncRequestStatus.NotStarted,
      data: {
        experimentId: "",
        error: "",
        experimentJournal: {
          jounalEntries: []
        }
      }
    },
    qualityAlertResultAsync: {
      status: AsyncRequestStatus.NotStarted,
      data: {
        error: "",
        result: {
          pendingShutdownTime: void 0,
          qualityAlerts: []
        },
        id: ""
      }
    },
    resolveAlertResultAsync: {
      status: AsyncRequestStatus.NotStarted,
      data: {
        error: "",
        result: ""
      }
    },
    viewAndResolveAlertsOpen: false
  };
};
const AlertReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case AlertConstants.LOAD_OPERATION_CHECKS:
      const r1 = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        operationAlertResult: __spreadProps(__spreadValues({}, state.operationAlertResult), {
          data: __spreadProps(__spreadValues({}, !!state.operationAlertResult.data ? state.operationAlertResult.data : getDefaultState().operationAlertResult.data), {
            experimentId: r1.experimentId
          })
        })
      });
    case AlertConstants.LOADING_OPERATION_CHECKS:
      return __spreadProps(__spreadValues({}, state), {
        operationAlertResult: __spreadProps(__spreadValues({}, state.operationAlertResult), {
          status: AsyncRequestStatus.Pending
        })
      });
    case AlertConstants.LOADED_OPERATION_CHECKS:
      const result = actionResult;
      if (!result || !result.operationAlertResult) {
        return __spreadProps(__spreadValues({}, state), {
          operationAlertResult: __spreadProps(__spreadValues({}, state.operationAlertResult), {
            status: AsyncRequestStatus.Failed
          })
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        operationAlertResult: __spreadProps(__spreadValues({}, state.operationAlertResult), {
          status: !!result.operationAlertResult.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          data: {
            experimentId: !!state.operationAlertResult.data ? state.operationAlertResult.data.experimentId : "",
            error: result.operationAlertResult.error,
            operationAlertDictionary: result.operationAlertResult.operationAlertDictionary
          }
        })
      });
    case AlertConstants.LOAD_EXPERIMENT_JOURNAL:
      const r2 = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experimentJournalResult: __spreadProps(__spreadValues({}, state.experimentJournalResult), {
          data: __spreadProps(__spreadValues({}, !!state.experimentJournalResult.data ? state.experimentJournalResult.data : getDefaultState().experimentJournalResult.data), {
            experimentId: r2.experimentId
          })
        })
      });
    case AlertConstants.LOADING_EXPERIMENT_JOURNAL:
      return __spreadProps(__spreadValues({}, state), {
        experimentJournalResult: __spreadProps(__spreadValues({}, state.experimentJournalResult), {
          status: AsyncRequestStatus.Pending
        })
      });
    case AlertConstants.LOADED_EXPERIMENT_JOURNAL:
      const result1 = actionResult;
      if (!result1 || !result1.experimentJournalResult) {
        return __spreadProps(__spreadValues({}, state), {
          experimentJournalResult: __spreadProps(__spreadValues({}, state.experimentJournalResult), {
            status: AsyncRequestStatus.Failed
          })
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        experimentJournalResult: __spreadProps(__spreadValues({}, state.experimentJournalResult), {
          status: !!result1.experimentJournalResult.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          data: {
            experimentId: !!state.experimentJournalResult.data ? state.experimentJournalResult.data.experimentId : "",
            error: result1.experimentJournalResult.error,
            experimentJournal: result1.experimentJournalResult.experimentJournal
          }
        })
      });
    case AlertConstants.LOAD_QUALITY_ALERTS:
      const loadQualityAlertsAR = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        qualityAlertResultAsync: __spreadProps(__spreadValues({}, state.qualityAlertResultAsync), {
          data: __spreadProps(__spreadValues({}, !!state.qualityAlertResultAsync.data ? state.qualityAlertResultAsync.data : getDefaultState().qualityAlertResultAsync.data), {
            id: loadQualityAlertsAR.experimentId
          })
        })
      });
    case AlertConstants.LOADING_QUALITY_ALERTS:
      return __spreadProps(__spreadValues({}, state), {
        qualityAlertResultAsync: __spreadProps(__spreadValues({}, state.qualityAlertResultAsync), {
          status: AsyncRequestStatus.Pending
        })
      });
    case AlertConstants.LOADED_QUALITY_ALERTS:
      const resultQualityAlerts = actionResult;
      if (!resultQualityAlerts || !resultQualityAlerts.qualityAlerts) {
        return __spreadProps(__spreadValues({}, state), {
          qualityAlertResultAsync: __spreadProps(__spreadValues({}, state.qualityAlertResultAsync), {
            status: AsyncRequestStatus.Failed
          })
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        qualityAlertResultAsync: __spreadProps(__spreadValues({}, state.qualityAlertResultAsync), {
          status: !!resultQualityAlerts.qualityAlerts.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          data: {
            error: resultQualityAlerts.qualityAlerts.error,
            result: resultQualityAlerts.qualityAlerts.result,
            id: resultQualityAlerts.qualityAlerts.id
          }
        })
      });
    case AlertConstants.RESOLVING_QUALITY_ALERTS:
      return __spreadProps(__spreadValues({}, state), {
        resolveAlertResultAsync: __spreadProps(__spreadValues({}, state.resolveAlertResultAsync), {
          status: AsyncRequestStatus.Pending
        })
      });
    case AlertConstants.RESOLVED_QUALITY_ALERTS:
      const resultResolveQualityAlerts = actionResult;
      if (!resultResolveQualityAlerts || !resultResolveQualityAlerts.engageResult) {
        return __spreadProps(__spreadValues({}, state), {
          resolveAlertResultAsync: __spreadProps(__spreadValues({}, state.resolveAlertResultAsync), {
            status: AsyncRequestStatus.Failed
          })
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        resolveAlertResultAsync: __spreadProps(__spreadValues({}, state.resolveAlertResultAsync), {
          status: !!resultResolveQualityAlerts.engageResult.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          data: {
            error: resultResolveQualityAlerts.engageResult.error,
            result: resultResolveQualityAlerts.engageResult.result
          }
        })
      });
    case AlertConstants.TOGGLE_VIEW_AND_RESOLVE_ALERTS:
      const aResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        viewAndResolveAlertsOpen: aResult.openPanel
      });
    default:
      return state;
  }
};
export {
  AlertReducer,
  AlertReducer as default,
  getDefaultState
};
//# sourceMappingURL=AlertReducer.js.map
